import {DRAFT_STORE_BLUEPRINT} from "@/common/utils/constants.js";
import * as IMAGE_SERVICE from "@/drc/services/image.service";

const state = {
	id: null,
	sourceLanguage: "",
	currentStep: 0,
	progressionStep: 0,
	customerName: "",
	industry: null,
	subIndustry: null,
	logo: {
		id: null,
		objectKey: null,
		objectUrl: null
	},
	mainImage: {
		id: null,
		objectKey: null,
		objectUrl: null
	},
	confidentiality: {},
	isNewBusiness: false,
	clientCountries: [],
	isProjectOngoing: false,
	dateFromYear: null,
	dateFromMonth: null,
	dateToYear: null,
	dateToMonth: null,
	businessLines: [],
	modisOfferings: [],
	fte: {
		id: null,
		label: null
	},
	revenue: {
		id: null,
		label: null
	},
	tools: [],
	certification: [],
	modisCountries: [],
	aboutTheClient: "",
	akkodisResult: "",
	clientResult: "",
	solution: "",
	akkodisChallenge: "",
	clientContext: "",
	testimonials: [
		{
			name: "",
			jobRole: "",
			customerQuote: "",
		}
	],
	deliveryContactManager: {
		email: "",
		fullName: ""
	},
	businessContactManager: {
		email: "",
		fullName: ""
	},
	links: [{
		keyword: '',
		url: ''
	}],
	createdBy: "",
	gallery: [],
	galleryNew: [],
	stepStatus: true,
};

const getters = {
	getFieldValue: (state) => (fieldName) => {
		return state[fieldName];
	},
	getStepStatus(state) {
		return state.stepStatus;
	},
	getStoreData(state) {
		return state;
	}
};

const actions = {
	changeStepStatus({commit}, payload) {
		commit("changeStepStatus", payload);
	},
	resetStepStatus({commit}, payload) {
		commit('resetStepStatus', payload);
	},
	changeProgressionStep({commit}, step) {
		commit("changeProgressionStep", step);
	},
	changeSingleNestedField({commit}, payload) {
		commit("changeSingleNestedField", payload)
	},
	changeCurrentStep({commit}, step) {
		commit("changeCurrentStep", step);
	},
	changeSingleField({commit}, payload) {
		commit("changeSingleField", payload)
	},
	changeSimpleMultiValueField({commit}, payload) {
		commit('changeSimpleMultiValueField', payload);
	},
	complexMultiValueHasChanged({commit}, payload) {
		commit('complexMultiValueHasChanged', payload);
	},
	addTestimonial({commit}) {
		let newTestimonial = {
			name: "",
			jobRole: "",
			customerQuote: "",
		};

		commit("addTestimonial", newTestimonial);
	},
	editTestimonialValue({commit}, payload) {
		commit("editTestimonialValue", payload);
	},
	removeTestimonial({commit}, payload) {
		commit("removeTestimonial", payload);
	},
	addLink({commit}) {
		let newLink = {
			keyword: '',
			url: ''
		};

		commit("addLink", newLink);
	},
	editLinkValue({commit}, payload) {
		commit('editLinkValue', payload);
	},
	removeLink({commit}, payload) {
		commit('removeLink', payload);
	},
	syncStore({commit}, payload) {
		commit('syncStore', payload);

		if (payload.links.length === 0) {
			let newLink = {
				keyword: '',
				url: ''
			};
			commit('addLink', newLink);
		}

		if (payload.deliveryContactManager == null) {
			commit('addEmptyDeliveryContact');
		}

		if (payload.businessContactManager == null) {
			commit('addEmptyContactManager');
		}
	},
	addNewGalleryImage({commit}, payload) {
		commit('addNewGalleryImage', payload);
	},
	removeNewGalleryImage({commit}, index) {
		commit('removeNewGalleryImage', index);
	},
	removeGalleryImageId({commit}, imageId) {
		commit('removeGalleryImagaId', imageId);
	},
	resetDraftStore({commit}) {
		commit('resetDraftStore');
	}
};

const mutations = {
	changeStepStatus(state, payload) {
		if (state.stepStatus) {
			state.stepStatus = payload;
		}
	},
	resetStepStatus(state, payload) {
		state.stepStatus = payload;
	},
	changeProgressionStep(state, step) {
		if (state.progressionStep < step) {
			state.progressionStep = step;
		}
	},
	changeCurrentStep(state, step) {
		state.currentStep = step;
	},
	changeSingleField(state, payload) {
		state[payload.fieldName] = payload.value;
	},
	changeSimpleMultiValueField(state, payload) {
		if (state[payload.fieldName].includes(payload.value)) {
			let index = state[payload.fieldName].findIndex((element) => element == payload.value);
			state[payload.fieldName].splice(index, 1);
		} else {
			state[payload.fieldName].push(payload.value);
		}
	},
	complexMultiValueHasChanged(state, payload) {
		let isMainSelected = state[payload.fieldName].find((option) => option.id === payload.value.id);
		let mainIndex = state[payload.fieldName].findIndex((option) => option.id === payload.value.id);

		if (isMainSelected != undefined) {

			if (payload.value.subOption) {
				let isSubSelectd = isMainSelected.subOptions.find((subOption) => subOption.id === payload.value.subOption.id);

				if (isSubSelectd != undefined) {
					let subIndex = isMainSelected.subOptions.findIndex((option) => option.id === payload.value.subOption.id);
					state[payload.fieldName][mainIndex].subOptions.splice(subIndex, 1);
					// if no more sub options selected remove the main
					if (!state[payload.fieldName][mainIndex].subOptions.length) {
						state[payload.fieldName].splice(mainIndex, 1);
					}
				} else {
					state[payload.fieldName][mainIndex].subOptions.push(payload.value.subOption);
				}

			} else {
				state[payload.fieldName].splice(mainIndex, 1);
			}

		} else {
			state[payload.fieldName]
				.push({
					id: payload.value.id,
					subOptions: payload.value.subOption ? [payload.value.subOption] : null
				});
		}
	},
	addTestimonial(state, payload) {
		state.testimonials.push(payload);
	},
	editTestimonialValue(state, payload) {
		state.testimonials[payload.index][payload.fieldName] = payload.value;
	},
	removeTestimonial(state, payload) {
		state.testimonials.splice(payload, 1);
	},
	addLink(state, payload) {
		state.links.push(payload);
	},
	editLinkValue(state, payload) {
		state.links[payload.index][payload.fieldName] = payload.value;
	},
	removeLink(state, payload) {
		state.links.splice(payload, 1);
	},
	syncStore(state, payload) {

		if (payload.testimonials.length > 0) {
			payload.testimonials = payload.testimonials.map(testimonial => {
				let translation = testimonial.translations.find(translation => translation.language.name === payload.sourceLanguage);
				return {
					name: translation.name,
					jobRole: translation.jobRole,
					customerQuote: translation.customerQuote,
				}
			})
		} else {
			payload.testimonials = [
				{
					name: "",
					jobRole: "",
					customerQuote: "",
				}
			]
		}

		Object.assign(state, payload);
		const images = state.projectImages;
		state.mainImage = IMAGE_SERVICE.getMainImageObject(images);
		state.logo = IMAGE_SERVICE.getLogoImageObject(images);
		state.gallery = IMAGE_SERVICE.getCarouselImageObjects(images);
	},
	addEmptyContactManager(state) {
		state.businessContactManager = {
			fullName: '',
			email: ''
		}
	},
	addEmptyDeliveryContact(state) {
		state.deliveryContactManager = {
			fullName: '',
			email: ''
		}
	},
	addNewGalleryImage(state, payload) {
		state.galleryNew.push(payload);
	},
	removeNewGalleryImage(state, payload) {
		let index = -1;
		for (let i = 0; i < state.galleryNew.length; i++) {
			if (state.galleryNew[i].lastModified === payload) {
				index = i;
			}
		}
		state.galleryNew.splice(index, 1);
	},
	removeGalleryImagaId(state, imageId) {
		let removeIndex = state.gallery.findIndex((image) => {
			return image.id === imageId;
		});

		state.gallery.splice(removeIndex, 1);
	},
	resetDraftStore(state) {
		Object.assign(state, DRAFT_STORE_BLUEPRINT);
		state.clientCountries = [];
		state.modisCountries = [];
		state.links = [];
		state.gallery = [];
		state.galleryNew = [];
		state.tools = [];
		state.certification = [];
		state.businessLines = [];
		state.modisOfferings = [];
		state.testimonials = [
			{
			name: "",
			jobRole: "",
			customerQuote: "",
		}
	];
		if (Object.prototype.hasOwnProperty.call(state, "projectImages")) {
			delete state.projectImages
		}

		if (Object.prototype.hasOwnProperty.call(state, "referenceTitle")) {
			delete state.referenceTitle
		}

		if (Object.prototype.hasOwnProperty.call(state, "industries")) {
			delete state.industries
		}
	},
	changeSingleNestedField(state, payload) {
		let [mainField, nestedField] = payload.fieldName.split('_');
		state[mainField][nestedField] = payload.value;
	}
};

export default {state, getters, actions, mutations};
